import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { SHOW_SNACKBAR } from "../Utils/types";

const SnackBar = () => {
  const dispatch = useDispatch();
  const { message, type, open,time } = useSelector(
    (state) => state.globalReducer.snackbar
  );

  useEffect(() => {
    if (open) {
      setTimeout(
        () =>
          dispatch({
            type: SHOW_SNACKBAR,
            payload: { open: false, type: "", message: "" },
          }),
        time
      );
    }
  }, [open]);

  return (
    open && (
      <div
        className="snackbar snackbar_show snackbar-wrapper"
        style={{
          borderLeft:
            type === "success"
              ? "6px solid #47d764"
              : type === "error"
              ? "6px solid #ff355b"
              : type === "info" && "6px solid #007bff",
              zIndex: "99999"
        }}
      >
        <div className="outer-container">
          {type === "success" && (
            <i
              style={{ color: "#47d764" }}
              className="icon-color fas fa-check-circle"
            ></i>
          )}
          {type === "error" && (
            <i
              style={{ color: "#ff355b" }}
              className="icon-color fas fa-times-circle"
            ></i>
          )}
          {type === "warning" && (
            <i
              style={{ color: "#FFC021" }}
              className="icon-color fas fa-exclamation-circle"
            ></i>
          )}
           {type === "info" && (
            <i
              style={{ color: "#007bff" }}
              className="icon-color fas fa-circle-info"
            ></i>
          )}
        </div>
        <div className="inner-container">
          <p className="snackbar-type">
            {type === "error" && "Error"}
            {type === "warning" && "Warning"}
            {type === "success" && "Success"}
            {type === "info" && "Info"}
          </p>
          <p className="snackbar-message">{message}</p>
        </div>
        <button
          type="button"
          onClick={() => {
            dispatch({
              type: SHOW_SNACKBAR,
              payload: { open: false, type: "", message: "" },
            });
          }}
          className="snackbar-close-button"
        >
          &times;
        </button>
      </div>
    )
  );
};

export default SnackBar;
